import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import * as CryptoJS from "crypto-js";
import { TabService } from 'src/app/utils/TabService';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-creater-user',
  templateUrl: './creater-user.component.html',
  styleUrls: ['./creater-user.component.scss'],
  providers: [MessageService, ConfirmationService, TabService]
})
export class CreaterUserComponent implements OnInit {

  // FORM REGISTER
  validateUserForm: FormGroup;
  isValid: boolean;

  // SECURITY 
  currentUser: any;
  security: SecurityDocument;
  selLang: string;

  // LANGUAGE
  lbl_recover_password: string = "recover_password_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_guide_id: string = "guideId_";
  lbl_request: string = "request_";
  lbl_go_Back: string = "back_";
  lbl_id: string = "id_";
  lbl_validate: string = "validate_";
  lbl_user: string = "user_";
  lbl_password: string = "password_";
  lbl_confirm: string = "confirm_";
  lbl_accept: string = "accept_";
  lbl_does_not_match: string = "does_not_match_";
  lbl_updated_data: string = "updated_data_";
  lbl_for: string = "for_";
  lbl_future_guide: string = "future_guide_";
  lbl_entry: string = "entry_";
  lbl_guideId: string = "guideId_";
  lbl_and: string = "and_";
  lbl_email: string = "email_";
  lbl_guide: string = "guide_";
  lbl_certificate: string = "certificate_";


  button_save: boolean = false;
  device: string;

  /**
   * This is a constructor function that initializes various services and dependencies for a TypeScript
   * class.
   * @param {FormBuilder} formBuilder - The formBuilder is a service provided by Angular that allows you
   * to create and manage forms in your application. It provides methods for creating form controls, form
   * groups, and form arrays, as well as methods for validating and submitting forms.
   * @param {MessageService} messageService - The `messageService` is a service that provides methods for
   * displaying messages to the user, such as success messages, error messages, and informational
   * messages. It is likely used to provide feedback to the user after certain actions are taken in the
   * application.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service provided
   * by the PrimeNG library that allows for displaying confirmation dialogs to the user. It can be used
   * to confirm actions before they are executed, such as deleting a record or submitting a form. The
   * service provides methods for displaying different types of confirmation dialogs and handling the
   * @param {ApiService} apiService - The `apiService` parameter is an instance of a service that
   * provides methods for making HTTP requests to an API. It is likely used to retrieve or send data to a
   * backend server.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It is used to navigate to different
   * routes and pass data between components. The router is injected into a component or service using
   * dependency injection.
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter is an
   * instance of a service that handles user authentication and authorization. It is likely used to check
   * if a user is logged in and has the necessary permissions to perform certain actions within the
   * application.
   */
  constructor(private formBuilder: FormBuilder, private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router) {
    this.route.queryParams.subscribe(
      params => {
        this.device = params.device;
        this.selLang = params.language;
      });
    if (this.device) {
      if (this.device) {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
    }
  }

  /**
   * The ngOnInit function initializes variables and sets up form validations in a TypeScript file.
   */
  ngOnInit(): void {


    // SET IS'NT VALID
    this.isValid = false;

    // FORMS DECLARATIONS 
    this.validateUserForm = this.formBuilder.group({
      "currentEmail": new FormControl("", [
        Validators.required,
        Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"),
        Validators.maxLength(100),
        Validators.minLength(2),
      ]),
      "currentCertified": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(2),
      ]),
      "currentIdGuide": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(2),
      ]),
      "name": new FormControl("", [
        Validators.required,
        Validators.pattern("[a-zA-Z ]{2,254}"),
        Validators.maxLength(100),
        Validators.minLength(2),
      ]),
      "confirmPassword": new FormControl("", [
        Validators.required,
        Validators.maxLength(15),
        Validators.minLength(6),
      ]),
      "password": new FormControl("", [
        Validators.required,
        Validators.maxLength(15),
        Validators.minLength(6),
      ]),
    });

    this.validateUserForm.get('confirmPassword').setValidators(
      this.equalsValidator(this.validateUserForm.get('password'))
    );
  }


  /**
   * The function checks if a user validation form is valid and processes it if it is, otherwise it
   * prevents the default event and validates all form fields.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function call. It could be a mouse click, a key press, or any other user interaction with the page.
   * In this case, it is used to prevent the default behavior of the form submission if the form is not
   * valid.
   */
  confirmvalidateUser(event) {

    let body = {
      email: this.validateUserForm.controls["currentEmail"].value,
      certif: this.validateUserForm.controls["currentCertified"].value,
      guideId: this.validateUserForm.controls["currentIdGuide"].value,
      language: this.selLang,
      transaction: "crtUsr"
    }
    this.apiService.validateAccess_getGuideId(body).then(
      data => {
        if (data != null && data.code == 0) {
          this.isValid = true;
          this.validateUserForm.controls["name"].setValue(data.user);
        } else {
          this.messageService.add({ key: 'tst', severity: 'error', summary: data.message, detail: ' ', life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ key: "tst", severity: 'error', summary: 'Validar Usuario', detail: error, life: 9000 });
      });
  }

  /**
   * The function confirms the creation of a user by validating the user form and displaying a success
   * message if the form is valid.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. It could be a button click, form submission, or any other user interaction that calls the
   * function. The function uses the event parameter to prevent the default behavior of the event if the
   * form is not valid.
   */
  confirmCreateUser(event) {
    const hash = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(this.validateUserForm.controls["password"].value));
    const md5 = hash.toString(CryptoJS.enc.Hex)
    let formStatus: boolean = (
      this.validateUserForm.controls["name"].valid
      && this.validateUserForm.controls["password"].valid
      && this.validateUserForm.controls["confirmPassword"].valid);
    if (!formStatus || !this.validateUserForm.controls["confirmPassword"].value) {
      event.preventDefault();
      this.validateAllFormFields(this.validateUserForm);
    } else {
      this.button_save = true;
      // HERE API CALL AND SAVE 
      let body = {
        email: this.validateUserForm.controls["currentEmail"].value,
        certificate: this.validateUserForm.controls["currentCertified"].value,
        guideId: this.validateUserForm.controls["currentIdGuide"].value,
        language: this.selLang,
        user: this.validateUserForm.controls["name"].value,
        pass: md5,
      }

      this.apiService.createUser(body).then(
        data => {
          if (data != null && data.code == 0) {
            this.isValid = false;
            this.resetForms();
            this.messageService.add({ key: 'tst', severity: 'success', summary: this.lbl_updated_data, detail: this.lbl_entry + " SANTOV", life: 10000 });
            this.button_save = false;
          } else {
            this.messageService.add({ key: 'tst', severity: 'error', summary: data.message, detail: ' ', life: 10000 });
            this.button_save = false;
          }

        }).catch(error => {
          console.error(error);
          this.button_save = false;
          this.messageService.add({ key: "tst", severity: 'error', summary: 'Validar Usuario', detail: error, life: 9000 });
        });

    }
  }

  /**
   * The function resets a user form by calling the reset method on a validation object.
   */
  resetForms() {
    this.validateUserForm.reset();
  }

  /**
   * This function recursively marks all form controls in a FormGroup as touched.
   * @param {FormGroup} formGroup - The formGroup parameter is a FormGroup object, which is a collection
   * of FormControl objects that are used to represent a form in Angular. It is used to group related
   * form controls together and manage their values and validation. The validateAllFormFields() function
   * is a helper function that recursively marks all form controls in
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   * This function authenticates a user by calling a login function and subscribing to the response.
   * @param {string} user - A string representing the username of the user trying to authenticate.
   * @param {string} password - The password parameter is a string that represents the user's password.
   * It is used as a parameter for the authenticationService's login method to authenticate the user.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.currentUser = this.authenticationService.currentUserValue;
            this.getSecurity();
          }
        },
        error => {
          console.error(error);
        });

  }

  /**
   * The function retrieves security information for the current user and sets the language and
   * translated labels accordingly.
   */
  getSecurity() {
    this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;

        if (this.security) {
          this.getTranslatedLabels();

        }
      });
  }

  /**
   * This function retrieves translated labels from an API and updates the corresponding variables with
   * the translated values.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.selLang != null ? this.selLang : window.navigator.language.split("-")[0],
      'region': this.security.region,
      'lstLabels': [this.lbl_recover_password, this.lbl_email, this.lbl_certificate, this.lbl_cell_phone, this.lbl_guide_id, this.lbl_request, this.lbl_go_Back, this.lbl_entry, this.lbl_id, this.lbl_guide, this.lbl_validate, this.lbl_user, this.lbl_password, this.lbl_confirm, this.lbl_accept, this.lbl_does_not_match, this.lbl_updated_data, this.lbl_for, this.lbl_future_guide, this.lbl_and, this.lbl_guideId]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_recover_password = map.get(this.lbl_recover_password);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_request = map.get(this.lbl_request);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_entry = map.get(this.lbl_entry);
        this.lbl_id = map.get(this.lbl_id);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_validate = map.get(this.lbl_validate);
        this.lbl_user = map.get(this.lbl_user);
        this.lbl_password = map.get(this.lbl_password);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_accept = map.get(this.lbl_accept);
        this.lbl_does_not_match = map.get(this.lbl_does_not_match);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_for = map.get(this.lbl_for);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_and = map.get(this.lbl_and);
      });
  }

  /**
   * The function "goBack" closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `equalsValidator` returns a validator function that checks if the value of the current
   * control is equal to the value of another control.
   * @param {AbstractControl} otherControl - `otherControl` is an `AbstractControl` parameter that
   * represents another form control in Angular forms. It is used in the `equalsValidator` function to
   * compare its value with the value of the control being validated.
   * @returns A validator function is being returned. This function compares the value of the control
   * with the value of another control (specified by `otherControl`). If the values are not equal, a
   * validation error object is returned with the key `'notEquals'` and the values that are being
   * compared. If the values are equal, `null` is returned indicating that the validation has passed.
   */
  equalsValidator(otherControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value: any = control.value;
      const otherValue: any = otherControl.value;
      return otherValue === value ? null : { 'notEquals': { value, otherValue } };
    };
  }
}